var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "delete-disclaimer-modal",
      "modal-dialog-scrollable": false,
      "footer-class": "d-flex justify-content-between",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t(
                    "settings.disclaimers.modal.deleteDisclaimerConfirmation"
                  )
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("settings.disclaimers.modal.confirmDeleteDisclaimer")
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              [
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("confirm-enable-default", false)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("settings.disclaimers.modal.noThankYou")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("confirm-enable-default", true)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "settings.disclaimers.modal.yesEnableDefaultDisclaimer"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }